<template>
  <v-flex>
    <v-container grid-list-xl class="w--max--800">
      <v-layout column text-xs-center>
        <v-flex tag="h2" class="mt-5">
          Choose a plan to find your NannyGranny
        </v-flex>

        <v-flex>
          <AppplanReview />
        </v-flex>

      </v-layout>
    </v-container>

   
    <!-- <div class="text-center">
      <h2 class="featured-heading ml-4">As featured in</h2>

      <div class="partnership-carousel-container">
        <div 
          ref="carouselScrollDiv" 
          class="partnership-carousel-wrapper"
          @mouseenter="pauseAutoScroll"
          @mouseleave="resumeAutoScroll"
        >
          <div class="carousel-track" :style="{ transform: `translateX(${scrollPosition}px)` }">
            
            <v-card
              v-for="(partner, index) in partners2"
              :key="`first-${index}`"
              class="mx-4 d-flex align-center justify-center no-border-card carousel-item"
              width="170"
              height="100"
              elevation="0"
            >
              <v-img :src="partner.icon" :alt="partner.name" contain class="carousel-image" />
            </v-card>
            
            
            <v-card
              v-for="(partner, index) in partners2"
              :key="`second-${index}`"
              class="mx-4 d-flex align-center justify-center no-border-card carousel-item"
              width="170"
              height="100"
              elevation="0"
            >
              <v-img :src="partner.icon" :alt="partner.name" contain class="carousel-image" />
            </v-card>
          </div>
        </div>
      </div>
    </div> -->
  </v-flex>
</template>

<script>
import AppplanReview from '../../../../components/app-buttons/app-btn-toggle-plan'
import AppContainerReview from '../../../../components/app-container-review'

export default {
  name: 'AppHomePlansRender',
  components: {
    AppplanReview,
    AppContainerReview,
  },
  data() {
    return {
      partners2: [
        { name: 'Bandt', icon: require('@/assets/img/bandt.png') },
        { name: 'Embed', icon: require('@/assets/img/image11.png') },
        { name: 'Jobs', icon: require('@/assets/img/thesydney.png') },
        { name: 'XYZ', icon: require('@/assets/img/image13.png') },
        { name: 'ABC', icon: require('@/assets/img/image10.png') },
        { name: 'MNO', icon: require('@/assets/img/mediaweek.png') },
        { name: 'DEF', icon: require('@/assets/img/image9.png') },
        { name: 'GHI', icon: require('@/assets/img/image2.png.png') },
        { name: 'JKL', icon: require('@/assets/img/nanny2.png') },
        { name: 'HAR', icon: require('@/assets/img/nanny3.png') },
        { name: 'hyj', icon: require('@/assets/img/image12.png') },
      ],
      autoScrollInterval: null,
      scrollPosition: 0,
      scrollSpeed: 1,
      itemWidth: 202, 
      isPaused: false,
    }
  },
  mounted() {
    // Initialize scroll position to show duplicated items from left
    const maxScroll = this.partners2.length * this.itemWidth
    this.scrollPosition = -maxScroll
    this.startAutoScroll()
  },
  beforeDestroy() {
    this.stopAutoScroll()
  },
  methods: {
    startAutoScroll() {
      this.autoScrollInterval = setInterval(() => {
        if (!this.isPaused) {
          // Move from left to right (negative to positive)
          this.scrollPosition += this.scrollSpeed
          
          // Reset when we've scrolled through all items
          const maxScroll = this.partners2.length * this.itemWidth
          if (this.scrollPosition >= 0) {
            this.scrollPosition = -maxScroll
          }
        }
      }, 12) // 60fps
    },
    
    stopAutoScroll() {
      if (this.autoScrollInterval) {
        clearInterval(this.autoScrollInterval)
        this.autoScrollInterval = null
      }
    },
    
    pauseAutoScroll() {
      this.isPaused = true
    },
    
    resumeAutoScroll() {
      this.isPaused = false
    }
  }
}
</script>

<style lang="stylus" scoped>
.no-border-card
  box-shadow none !important
  border none !important
  background-color transparent !important

.w--max--800
  max-width 900px !important

.partnership-carousel-container
  max-width 100%
  overflow hidden
  margin 20px 0
  
.partnership-carousel-wrapper
  width 100%
  overflow hidden
  position relative
  height 120px
  
.carousel-track
  display flex
  align-items center
  transition none
  will-change transform
  
.carousel-item
  flex-shrink 0
  
.carousel-image
  height 100px
  width auto
  max-width 120px
  transition all 0.3s ease
  
.carousel-item:hover .carousel-image
  transform scale(1.5)

.featured-heading
  font-size 24px
  font-weight bold
  color #444
  margin-bottom 20px

/* Optional: Add subtle animation */
@keyframes float
  0%, 100%
    transform translateY(0px)
  50%
    transform translateY(-2px)

.carousel-item:hover
  animation float 2s ease-in-out infinite
</style>


// WEBPACK FOOTER //
// src/views/app/home/components/app-home-plan.vue